// src/hooks/usePetState.js
import { useReducer, useCallback } from "react";
import { petsReducer, initialState } from "../reducers/petsReducer";
import { ACTIONS } from "../reducers/listActions";

export function usePetState() {
  const [state, dispatch] = useReducer(petsReducer, initialState);

  const setPage = useCallback((newPage) => {
    dispatch({ type: ACTIONS.SET_PAGE, payload: newPage });
  }, []);

  const setRowsPerPage = useCallback((newRows) => {
    dispatch({ type: ACTIONS.SET_ROWS_PER_PAGE, payload: newRows });
  }, []);

  // Add a sorting handler for pets
  const handleSortRequest = useCallback(
    (property) => {
      const isAsc = state.orderBy === property && state.order === "asc";
      const newOrder = isAsc ? "desc" : "asc";
      dispatch({ type: ACTIONS.SET_ORDER, payload: newOrder });
      dispatch({ type: ACTIONS.SET_ORDER_BY, payload: property });
      dispatch({ type: ACTIONS.SET_PAGE, payload: 0 }); // reset to first page
    },
    [state.order, state.orderBy]
  );

  return {
    state,         // Contains pets, loading, error, order, orderBy, page, rowsPerPage, totalPets
    dispatch,
    setPage,
    setRowsPerPage,
    handleSortRequest,
  };
}